<template>
  <div style="height:100%">
    <div class="uc-top-header"><div class="top-logo-bg"></div></div>
    <div class="content"><iframe src="https://account.glodon.com/newPrivacy" width="100%" height="100%" frameborder="0"></iframe> </div>
  </div>
</template>

<script>

export default {
  name: 'privacy',
  data () {
    return {
    }
  },
  components: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.uc-top-header {
    background-color: #0082DC;
    width: 100%;
    height: 64px;
    line-height: normal;
    z-index: 99;
    position: relative;
    .top-logo-bg {
    background: url('../../../../assets/images/acc-logo-bg.png') 0 22px no-repeat;
    float: left;
    margin: 0 0 0 40px;
    position: relative;
    width: 296px;
    height: 64px;
    display: block;
}
}
.content {
    width: 100%;
    height: calc(100vh - 64px);
    word-break: break-word;
    word-wrap: break-word;
    margin: 0 auto;
}
</style>
